import { IconButton } from "@chef/components";
import { Minus, Plus } from "@chef/icons/small";

import { getPlusPortionString } from "../../utils/recipe";

import { intl } from "./PortionsSelector.Intl";

interface PortionsSelectorProps {
  portionSizes: string[];
  setSelectedPortionSizeIndex: (newValue: number) => void;
  selectedPortionSizeIndex: number;
  variant?: "static" | "dynamic";
}

export const PortionsSelector = ({
  portionSizes,
  setSelectedPortionSizeIndex,
  selectedPortionSizeIndex,
  variant = "dynamic",
}: PortionsSelectorProps) => {
  const currentPortionSize = portionSizes[selectedPortionSizeIndex];

  const createPortionSizeString = () => {
    const portionSize = currentPortionSize.replace("+", "");

    if (variant === "static") {
      return `${portionSize} ${intl.PORTIONS}`;
    }

    return `${portionSize} pers${getPlusPortionString(currentPortionSize)}`;
  };

  const portionSizeString = createPortionSizeString();

  const isMinPortionSize = selectedPortionSizeIndex === 0;
  const isMaxPortionSize = selectedPortionSizeIndex === portionSizes.length - 1;

  return (
    <div className="flex items-center justify-between w-full">
      <h2 className="text-xl">
        <strong>Ingredienser</strong>
      </h2>

      <div className="print:hidden">
        {variant === "static" ? (
          <div>{portionSizeString}</div>
        ) : (
          <div className="flex items-center gap-3">
            <IconButton
              disabled={isMinPortionSize}
              label={intl.DECREASE_NUM_PORTIONS}
              onClick={() =>
                setSelectedPortionSizeIndex(selectedPortionSizeIndex - 1)
              }
            >
              <Minus />
            </IconButton>
            <div className="text-center lg:max-w-12">{portionSizeString}</div>

            <IconButton
              onClick={() =>
                setSelectedPortionSizeIndex(selectedPortionSizeIndex + 1)
              }
              disabled={isMaxPortionSize}
              label={intl.INCREASE_NUM_PORTIONS}
            >
              <Plus />
            </IconButton>
          </div>
        )}
      </div>

      <div className="hidden print:block">{portionSizeString}</div>
    </div>
  );
};
